export default __webpack_public_path__ + "static/media/logo-white.2df9e3d0.png";